import React from 'react'
import { useSwipeable } from 'react-swipeable'
import classNames from 'classnames'
import { useCalendar, CalendarController } from '../../useCalendar/useCalendar'
import CalendarWeekDays, { CalendarWeekDaysBaseProps } from './CalendarWeekdays/CalendarWeekdays'
import CalendarDays, { CalendarDaysBaseProps } from './CalendarDays/CalendarDays'
import styles from './calendar.css';
import CalendarNavigation, { CalendarNavigationBaseProps } from './CalendarNavigation/CalendarNavigation'

interface CalendarProps extends CalendarWeekDaysBaseProps, CalendarDaysBaseProps, CalendarNavigationBaseProps {
  calendarController?: CalendarController
  classes?: CalendarClasses
}

interface CalendarClasses {
  root?: string;
}


export default function Calendar({
  renderWeekDays, renderWeekends,
  renderSelectedDay,
  renderWeekendDay,
  weekDaysClasses,
  renderNavigation,
  dayClasses,
  calendarController = useCalendar({}),
  classes,
  renderDay,
  renderOutsideOfMonth,
}: CalendarProps) {

  const handlers = useSwipeable({
    onSwipedUp: () => {
      if (!calendarController.disableSwiping) {
        calendarController.swipeCalendarFormat(true);
      }
    },
    onSwipedDown: () => {
      if (!calendarController.disableSwiping) {
        calendarController.swipeCalendarFormat(false);
      }
    },
    onSwipedLeft: () => {
      if (!calendarController.disableSwiping) {
        calendarController.selectNext();
      }
    },
    onSwipedRight: () => {
      if (!calendarController.disableSwiping) {
        calendarController.selectPrevious();
      }
    },
  })

  return (
    <div {...handlers}>
      <div
        className={classNames({
          [styles.calendar]: true,
          [classes?.root || '']: !!classes?.root,
        })}
      >
        <CalendarNavigation
          focusedDay={calendarController.focusedDay}
          selectNext={calendarController.selectNext}
          selectPrevious={calendarController.selectPrevious}
          toggleCalendarFormat={calendarController.toggleCalendarFormat}
          renderNavigation={renderNavigation}
        />
        <div className={styles.calendarDaysView}>
          <div className={styles.calendarDaysViewWrapper}>
            <CalendarWeekDays
              weekendDays={calendarController.weekendDays}
              daysOfWeek={calendarController.daysOfWeek}
              renderWeekends={renderWeekends}
              renderWeekDays={renderWeekDays}
              weekDaysClasses={weekDaysClasses}
            />
            <CalendarDays
              renderDay={renderDay}
              renderSelectedDay={renderSelectedDay}
              renderWeekendDay={renderWeekendDay}
              onSelect={calendarController.setSelectedDay}
              visibleDays={calendarController.visibleDays}
              renderOutsideOfMonth={renderOutsideOfMonth}
              dayClasses={dayClasses}
              focusedDay={calendarController.focusedDay}
              selectedDay={calendarController.selectedDay}
              weekendDays={calendarController.weekendDays}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
